import axios from 'axios';
import { normalizePostMediaPayload } from './utils/postPayloadGuard';

/**
 * axiosConn CONTRACT (DO NOT VIOLATE)
 *
 * - baseURL is '/api/v1'
 * - All requests MUST be relative (no leading slash)
 *   ✅ axiosConn.get('posts/timeline/...')
 *   ❌ axiosConn.get('/posts/timeline/...')
 *
 * - axiosConn MUST NEVER be used for:
 *   • /auth/*
 *   • /share/*
 *   • /localops/*
 *   • /playermap/*
 *   • browser navigation
 *   • OG / email / magic links
 *
 * Violating this contract WILL cause hard-to-debug regressions.
 */

// Always point to the production API unless explicitly overridden
const axiosConn = axios.create({
  baseURL:
    process.env.REACT_APP_AZURE_API_BASE_URL ||
    process.env.REACT_APP_API_BASE_URL_PROD ||
    '/api/v1',
});

axiosConn.interceptors.request.use((config) => {
  const method = (config.method || 'get').toLowerCase();
  if (!['post', 'put', 'patch'].includes(method)) return config;
  const url = config.url || '';
  if (!/\/posts(\/|$)/.test(url)) return config;
  if (!config.data || typeof config.data !== 'object') return config;
  const normalized = normalizePostMediaPayload(config.data);
  if (normalized !== config.data) {
    config.data = normalized;
  }
  return config;
});

const FRONTEND_ROUTE_PREFIXES = [
  '/auth',
  '/share',
  '/localops',
  '/playermap',
  '/feed',
  '/login',
  '/register',
];

axiosConn.interceptors.request.use((config) => {
  const url = config.url || '';

  if (typeof url === 'string' && url.startsWith('/')) {
    const isFrontendRoute = FRONTEND_ROUTE_PREFIXES.some((p) =>
      url.startsWith(p),
    );

    if (isFrontendRoute) {
      throw new Error(`[axiosConn] Blocked request to frontend route: ${url}`);
    }

    // Leading slash bypasses baseURL — always invalid
    throw new Error(`[axiosConn] Invalid axiosConn usage (leading slash): ${url}`);
  }

  return config;
});

// AI RULE:
// If generating axiosConn code, NEVER use leading slashes.
// All axiosConn paths are relative to /api/v1.

export default axiosConn;
